import React from 'react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Textarea } from '../../ui/textarea';
import { 
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter 
} from '../../ui/dialog';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue
} from '../../ui/select';
import { ArrowRight, AlertCircle, Loader2 } from 'lucide-react';

export default function ModalAvancarLote({
  open,
  onOpenChange,
  lote,
  categoriaDestino,
  setCategoriaDestino,
  quantidadeAvancar,
  setQuantidadeAvancar,
  observacoesAvanco,
  setObservacoesAvanco,
  erroAvancar,
  saving,
  categoriasDestino,
  getCategoriaCor,
  onConfirm
}) {
  const pecasDisponiveis = (lote?.quantidade || 0) - (lote?.quantidade_alocada_seguinte || 0);
  
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ArrowRight className="h-5 w-5 text-blue-600" />
            Avançar Lote
          </DialogTitle>
          <DialogDescription>
            Avançar peças do lote <strong>{lote?.codigo_lote || `L${lote?.numero_lote}`}</strong> para a próxima categoria.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          {lote && (
            <div className="bg-stone-50 rounded-lg p-3 border">
              <div className="flex justify-between items-center mb-2">
                <span className="font-medium text-stone-700">Lote Origem</span>
                <span className={`text-xs px-2 py-0.5 rounded-full border ${getCategoriaCor(lote.categoria_codigo)}`}>
                  {lote.categoria_nome || 'Sem categoria'}
                </span>
              </div>
              <p className="text-2xl font-bold text-stone-900">
                {pecasDisponiveis} 
                <span className="text-sm font-normal"> peças disponíveis para alocar</span>
              </p>
              {(lote.quantidade_alocada_seguinte || 0) > 0 && (
                <p className="text-xs text-stone-500 mt-1">
                  Total: {lote.quantidade} peças | Já alocado: {lote.quantidade_alocada_seguinte} peças
                </p>
              )}
            </div>
          )}
          
          <div>
            <label className="block text-sm font-medium mb-1">
              Quantidade a avançar *
            </label>
            <Input
              type="number"
              min="1"
              max={pecasDisponiveis}
              value={quantidadeAvancar}
              onChange={(e) => setQuantidadeAvancar(e.target.value)}
              placeholder={`Máx: ${pecasDisponiveis}`}
              className="h-12"
              data-testid="input-quantidade-avancar"
            />
            <p className="text-xs text-stone-500 mt-1">
              {quantidadeAvancar && parseInt(quantidadeAvancar) > 0 
                ? `Após avançar, restarão ${pecasDisponiveis - parseInt(quantidadeAvancar)} peças disponíveis`
                : 'Indique quantas peças alocar à categoria seguinte'}
            </p>
          </div>
          
          <div>
            <label className="block text-sm font-medium mb-1">
              Categoria de destino *
            </label>
            <Select value={categoriaDestino} onValueChange={setCategoriaDestino}>
              <SelectTrigger data-testid="select-categoria-destino">
                <SelectValue placeholder="Selecione categoria..." />
              </SelectTrigger>
              <SelectContent>
                {categoriasDestino.map(cat => (
                  <SelectItem key={cat.id} value={cat.id}>
                    <span className="flex items-center gap-2">
                      <span className="font-mono text-xs bg-stone-100 px-1 rounded">{cat.codigo || '---'}</span>
                      {cat.nome}
                    </span>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          
          <div>
            <label className="block text-sm font-medium mb-1">
              Observações (opcional)
            </label>
            <Textarea
              value={observacoesAvanco}
              onChange={(e) => setObservacoesAvanco(e.target.value)}
              placeholder="Ex: Avançar para fase de acabamentos"
              rows={2}
            />
          </div>
          
          {erroAvancar && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg flex items-start gap-2">
              <AlertCircle className="h-5 w-5 mt-0.5 flex-shrink-0" />
              <p className="text-sm">{erroAvancar}</p>
            </div>
          )}
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button
            onClick={onConfirm}
            disabled={saving || !categoriaDestino || !quantidadeAvancar}
            className="bg-blue-600 hover:bg-blue-700"
            data-testid="btn-confirmar-avancar"
          >
            {saving ? (
              <Loader2 className="h-4 w-4 animate-spin mr-2" />
            ) : (
              <ArrowRight className="h-4 w-4 mr-2" />
            )}
            Avançar Lote
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
